module.exports = __webpack_public_path__ + "static/media/Under maintenance.ec8d20fe.png";